import {post, get} from '@/common/utils/Http';

export default {
  createTask: post('/task/create'),
  getUnconfirmedTasks: post('/task/getUnconfirmed'),
  setConfirmedTasks: post('/task/setConfirmed'),
  setConfirmedTask: post('/task/setConfirmedById'),
  getAllTasks: post('/task/getAll'),
  getTasksByTypes: post('/task/getByTypes'),
  getTime: post('/common/time'),
  confirmCrmTip: post('/common/confirmCrmTip'),
  isCrmTipConfirmed: post('/common/isCrmTipConfirmed'),
  deleteWxTplTemplate: post('/common/deleteWxTplTemplate'),
  saveWxTplTemplate: post('/common/saveWxTplTemplate'),
  getWxTplTemplates: post('/common/getWxTplTemplates'),
};
